class GarageDoor {
  constructor() {
    this.buyingJourney = document.querySelector("buying-journey");
    this.configurationPopup = document.querySelector("configuration-popup");
    this.aluminiumBifold = this;
    this.finishStepAt = 5;

    this.buyingJourneyApi = this.buyingJourney.buyingJourneyApi;
    // Dispatch the change event immediately after setting up the event listener

    //Object holding the information for whole Buying Journey.
    this.buyingJourneyObject = {
      id: null,
      title: null,
      productType: "garage_doors",
      panelInfo: {
        panelWidth: null,
        panelHeight: null,
        doorType: null,
        doorFitting: null,
      },
      panel: { value: null, totalPrice: 0 },
      panelMotorSide: { value: null, totalPrice: 0 },
      panelSize: {
        value: null,
        variantId: null,
        totalPrice: 0,
        quantity: 1,
        panelImage: null,
      },
      panelColour: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelOptionalExtras: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      postCode: { value: null },
      accessIssue: { value: null, orderNote: null },
      gtAccessQoute: {
        firstName: null,
        lastName: null,
        mobile: null,
        email: null,
      },
      totalPrice: 0,
      invoiceUrl: null,
    };

    // step functions that will perform calculation based on selection in previous steps
    this.stepActions = {
      0: () =>
        this.getWindowSize(
          this.buyingJourneyObject,
          this.buyingJourney.querySelectorAll(".step-size input")
        ),
      1: this.calculateDoorSize.bind(this),
      2: this.getDoorType.bind(this),
      3: this.getDoorFitting.bind(this),
      4: this.getMotorSide.bind(this),
      5: this.getColor.bind(this),
      6: this.getOptionalExtras.bind(this),
      7: this.getpostcode.bind(this),
      8: this.getGatewayAccessQuote.bind(this),
      9: this.buyingJourney.handleAddMoreProducts.bind(this.buyingJourney),
      10: this.buyingJourney.readyQuoteOverview.bind(this.buyingJourney),
    };

    this.priceData = {
      // Custom (Overall Width incl. Guides, 300 mm vs. 360 mm box)
      Classic: {
        widths: [
          1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200, 3400, 3600, 3800,
          4000, 4200, 4400, 4600, 4800, 5000, 5200, 5400,
        ],
        heights: [
          1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200, 3400, 3600, 3800,
          4000,
        ],
        grid: [
          [
            "863",
            "896",
            "928",
            "959",
            "992",
            "1023",
            "1057",
            "1088",
            "1120",
            "1151",
            "1185",
            "1217",
            "1249",
            "1280",
            "1312",
            "1345",
            "1377",
            "1408",
            "1441",
          ],
          [
            "886",
            "921",
            "955",
            "988",
            "1022",
            "1056",
            "1091",
            "1125",
            "1158",
            "1192",
            "1228",
            "1261",
            "1295",
            "1328",
            "1362",
            "1397",
            "1431",
            "1465",
            "1498",
          ],
          [
            "910",
            "947",
            "983",
            "1018",
            "1054",
            "1090",
            "1127",
            "1163",
            "1198",
            "1233",
            "1271",
            "1306",
            "1342",
            "1377",
            "1413",
            "1450",
            "1486",
            "1522",
            "1557",
          ],
          [
            "942",
            "982",
            "1021",
            "1059",
            "1097",
            "1136",
            "1176",
            "1215",
            "1253",
            "1291",
            "1332",
            "1370",
            "1409",
            "1447",
            "1486",
            "1526",
            "1565",
            "1603",
            "1641",
          ],
          [
            "975",
            "1018",
            "1059",
            "1100",
            "1142",
            "1183",
            "1226",
            "1268",
            "1309",
            "1350",
            "1394",
            "1435",
            "1476",
            "1517",
            "1559",
            "1602",
            "1643",
            "1684",
            "1725",
          ],
          [
            "997",
            "1042",
            "1085",
            "1129",
            "1172",
            "1215",
            "1260",
            "1304",
            "1347",
            "1390",
            "1435",
            "1478",
            "1522",
            "1565",
            "1608",
            "1653",
            "1696",
            "1739",
            "1782",
          ],
          [
            "1021",
            "1068",
            "1113",
            "1159",
            "1204",
            "1249",
            "1296",
            "1341",
            "1386",
            1431,
            1478,
            1524,
            1568,
            1614,
            1659,
            1706,
            1751,
            null,
            null,
          ],
          [
            1083,
            1133,
            1181,
            1229,
            1277,
            1325,
            1376,
            1423,
            1472,
            1519,
            1570,
            1617,
            1666,
            1713,
            1761,
            1811,
            1859,
            null,
            null,
          ],
          [
            1107,
            1160,
            1210,
            1259,
            1309,
            1359,
            1411,
            1461,
            1511,
            1561,
            1613,
            1662,
            1712,
            1762,
            1813,
            null,
            null,
            null,
            null,
          ],
          [
            1140,
            1195,
            1247,
            1300,
            1353,
            1406,
            1461,
            1514,
            1567,
            1619,
            1674,
            1727,
            1779,
            1832,
            null,
            null,
            null,
            null,
            null,
          ],
          [
            1172,
            1230,
            1285,
            1341,
            1397,
            1452,
            1511,
            1566,
            1622,
            1678,
            1735,
            1791,
            1847,
            null,
            null,
            null,
            null,
            null,
            null,
          ],
          [
            1196,
            1256,
            1314,
            1371,
            1429,
            1487,
            1546,
            1604,
            1661,
            1719,
            1778,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
          ],
        ],
      },

      // Classic (COMPACT, 55 mm lath + 66 mm guides, 205 mm vs. 250 mm box)
      Compact: {
        widths: [1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200, 3400],
        heights: [1800, 2000, 2200, 2400, 2600, 2800, 3000],
        grid: [
          // rows 1800–2400 are the 205 mm-box (dark-green) region ⇒ strings
          ["801", "834", "866", "897", "930", "961", "995", "1026", "1058"],
          ["824", "859", "893", "926", "960", "994", "1029", "1063", "1096"],
          ["848", "885", "921", "956", "992", "1027", "1065", "1101", "1136"],
          ["880", "920", "959", "997", "1035", "1074", "1114", "1153", "1191"],
          // rows 2600+ are the 250 mm-box (light-green) region ⇒ numbers
          [913, 956, 997, 1038, 1080, 1121, 1164, 1206, 1247],
          [874, 919, 962, 1006, 1049, 1092, 1137, 1181, 1224],
          [898, 945, 990, 1036, 1081, 1126, 1173, 1218, 1263],
        ],
      },
    };
  }

  connectedCallback() {
    this.render();
  }

  render() { }

  getVariant(passedWidth, passedHeight, type, findTheClosest = false) {
    const garageDoorsProducts = JSON.parse(
      document.querySelector("#garage-doors-products")?.textContent
    );
    const isClassic = type.toLowerCase().includes("classic");

    const highestWidth = isClassic ? 5400 : 3400;
    const highestHeight = isClassic ? 4000 : 3000;

    let isExactMatch = true;
    let width = passedWidth;
    let height = passedHeight;
    if (width > highestWidth) {
      width = highestWidth;
      isExactMatch = false;
    }
    if (height > highestHeight) {
      height = highestHeight;
      isExactMatch = false;
    }

    let variant = null;
    const product = garageDoorsProducts.find((product) => {
      if (product.title.toLowerCase().includes(type.toLowerCase())) {
        variant = product.variants.find((v) => {
          return +v.option1 === width && +v.option2 === height;
        });
        return variant;
      }
    });
    if (findTheClosest && !variant)
      return this.getVariant(width, height - 200, type, true);

    return {
      variant,
      product,
      isExactMatch,
    };
  }
  getGarageDoorObject(width, height, type, fitting) {
    // round up to nearest 100
    const roundedWidth = Math.ceil(width / 200) * 200;
    const roundedHeight = Math.ceil(height / 200) * 200;
    const isWithin = fitting.includes("Within");
    const isClassic = type.toLowerCase().includes("classic");
    const darkGreenVariants = JSON.parse(
      document.querySelector("#dark_green_variants")?.textContent
    );

    const { variant, product } = this.getVariant(
      roundedWidth,
      roundedHeight,
      type
    );
    if (isWithin) {
      const priceOject = JSON.parse(
        document.querySelector("#garage_box_sizes")?.textContent
      );
      const guide = isClassic
        ? priceOject.classic.guide
        : priceOject.compact.guide;
      let boxHeight = isClassic
        ? priceOject.classic.light_green_box
        : priceOject.compact.light_green_box;

      const isDarkGreen = darkGreenVariants.includes(String(variant.id));
      if (isDarkGreen)
        boxHeight = isClassic
          ? priceOject.classic.dark_green_box
          : priceOject.compact.dark_green_box;

      let calculatedWidth = width + guide * 2;
      let calculatedHeight = height + boxHeight;

      // round up to nearest 200
      calculatedWidth = Math.ceil(calculatedWidth / 200) * 200;
      calculatedHeight = Math.ceil(calculatedHeight / 200) * 200;

      const { variant: finalVariant, product: finalProduct } = this.getVariant(
        calculatedWidth,
        calculatedHeight,
        type,
        true
      );
      return {
        variant: finalVariant,
        product: finalProduct,
      };
    } else {
      const { variant: finalVariant, product: finalProduct } = this.getVariant(
        roundedWidth,
        roundedHeight,
        type
      );
      return {
        variant: finalVariant,
        product: finalProduct,
      };
    }
  }

  //First step assign event listener to input fields
  getWindowSize(productObject, inputs) {
    console.log("Garage doors: Panel width and height");
    inputs.forEach((input) => {
      if (input.name == "panel-width") {
        input.value = productObject.panelInfo.panelWidth;
      }
      if (input.name == "panel-height") {
        input.value = productObject.panelInfo.panelHeight;
      }
      //this.validateInput(productObject,input);

      this.validateInput(productObject, input)
        ? this.buyingJourney.setActiveNextButton()
        : this.buyingJourney.setDisableNextButton();
      input.addEventListener("input", () =>
        this.validateInput(productObject, input)
          ? this.buyingJourney.setActiveNextButton()
          : this.buyingJourney.setDisableNextButton()
      );

      input.dispatchEvent(this.buyingJourney.changeEvent);
    });
  }

  calculateDoorSize() {
    console.log("Door Type");

    const doorTypesElements = this.buyingJourney.querySelectorAll(
      'input[name="garage-doors-style"]'
    );

    doorTypesElements.forEach((doorType) => {
      const { product, isExactMatch } = this.getVariant(
        Math.ceil(this.buyingJourneyObject.panelInfo.panelWidth / 200) * 200,
        Math.ceil(this.buyingJourneyObject.panelInfo.panelHeight / 200) * 200,
        doorType.value
      );

      doorType.checked = false;
      doorType.disabled = false;

      if (!product || !isExactMatch) {
        doorType.disabled = true;
        doorType.checked = false;
      }
    });

    if (this.buyingJourneyObject.panelInfo.doorType != null) {
      const selectedDoorType = this.buyingJourney.querySelector(
        'input[value="' + this.buyingJourneyObject.panelInfo.doorType + '"]'
      );
      selectedDoorType.checked = true;
      selectedDoorType.dispatchEvent(this.buyingJourney.changeEvent);
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="garage-doors-style"]');
  }

  getDoorType() {
    console.log("Door Fitting");

    const selectedDoorType = this.buyingJourney.querySelector(
      'input[name="garage-doors-style"]:checked'
    );

    if (selectedDoorType) {
      this.buyingJourneyObject.panelInfo.doorType =
        selectedDoorType.value || null;

      this.buyingJourneyObject.panelSize.panelImage = selectedDoorType
        .closest(".panel-wrapper")
        .querySelector("img").src;
    }

    const selectedDoorFittingValue =
      this.buyingJourneyObject.panelInfo.doorFitting;

    if (selectedDoorFittingValue) {
      const selectedDoorFitting = this.buyingJourney.querySelector(
        `input[value="${selectedDoorFittingValue}"]`
      );
      selectedDoorFitting.checked = true;
      selectedDoorFitting.dispatchEvent(this.buyingJourney.changeEvent);
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="garage-doors:-setup"]');
  }

  getDoorFitting() {
    console.log("Motor Side");

    if (this.buyingJourneyObject.panelMotorSide.value != null) {
      const selectedMotorSide = this.buyingJourney.querySelector(
        'input[value="' + this.buyingJourneyObject.panelMotorSide.value + '"]'
      );
      selectedMotorSide.checked = true;
      selectedMotorSide.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedDoorFitting = this.buyingJourney.querySelector(
      'input[name="garage-doors:-setup"]:checked'
    );

    if (selectedDoorFitting) {
      this.buyingJourneyObject.panelInfo.doorFitting =
        selectedDoorFitting.value || "";

      const { variant, product } = this.getGarageDoorObject(
        this.buyingJourneyObject.panelInfo.panelWidth,
        this.buyingJourneyObject.panelInfo.panelHeight,
        this.buyingJourneyObject.panelInfo.doorType,
        this.buyingJourneyObject.panelInfo.doorFitting
      );

      if (!variant || !product) {
        this.buyingJourney.setDisableNextButton();
        console.log("No variant or product");
        return;
      }

      this.buyingJourneyObject.panelSize.totalPrice = this.convertPrice(
        variant.price / 100
      );
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="garage-doors-motor-side"]');
  }

  getMotorSide() {
    console.log("Panel Colour");
    if (this.buyingJourneyObject.panelColour.variantId != null) {
      const selectedColorOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelColour.variantId +
        '"]'
      );
      selectedColorOption.checked = true;
      selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedMotorSide = this.buyingJourney.querySelector(
      'input[name="garage-doors-motor-side"]:checked'
    );
    if (selectedMotorSide) {
      this.buyingJourneyObject.panelMotorSide.value =
        selectedMotorSide.value || "";
    }

    document
      .querySelectorAll('input[name="panel_outside_color"]')
      .forEach((colourItem) => {
        colourItem.addEventListener("change", function () { });
      });
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="garage_doors_ral_colours"]');
  }

  // show Optional Extras and get selected outside colour
  getColor() {
    console.log("Optional Extras");
    this.buyingJourney.setActiveNextButton();
    if (this.buyingJourneyObject.panelOptionalExtras.variantId != null) {
      const selectedOptionalExtras = this.buyingJourney.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelOptionalExtras.variantId +
        '"]'
      );
      selectedOptionalExtras.checked = true;
      selectedOptionalExtras.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedOutsideColor = this.buyingJourney.querySelector(
      'input[name="garage_doors_ral_colours"]:checked'
    );
    if (selectedOutsideColor) {
      this.buyingJourneyObject.panelColour.value =
        selectedOutsideColor.value || null;
      this.buyingJourneyObject.panelColour.variantId =
        selectedOutsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelColour.totalPrice = this.convertPrice(
        selectedOutsideColor.dataset.price
      );
      this.buyingJourneyObject.panelColour.quantity =
        parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    console.log(this.buyingJourneyObject);
    console.log("Hello Optional extras");
    const selectedOptionalExtrasIds =
      this.buyingJourneyObject.panelOptionalExtras?.values?.map(
        (value) => value.variantId
      );

    if (selectedOptionalExtrasIds) {
      const selectedOptionalExtras = this.buyingJourney.querySelectorAll(
        'input[name="garage-doors-optional-extras_size"]'
      );

      selectedOptionalExtras.forEach((input) => {
        if (selectedOptionalExtrasIds.includes(input.dataset.variantId)) {
          input.checked = true;
        }
      });
    }

    if (Object.keys(this.buyingJourney.personDetails).length > 0) {
      this.buyingJourneyObject.gtAccessQoute.firstName =
        this.buyingJourney.personDetails.firstName;
      this.buyingJourneyObject.gtAccessQoute.lastName =
        this.buyingJourney.personDetails.lastName;
      this.buyingJourneyObject.gtAccessQoute.email =
        this.buyingJourney.personDetails.email;
      this.buyingJourneyObject.gtAccessQoute.mobile =
        this.buyingJourney.personDetails.phone;
      this.buyingJourneyObject.postCode.value =
        this.buyingJourney.personDetails.postcode;
    }

    // this.setupOptionListeners('input[name="garage-doors-optional-extras_size"]');
  }

  getOptionalExtras() {
    console.log("PostCode");

    const selectedOptionalExtras = this.buyingJourney.querySelectorAll(
      'input[name="garage-doors-optional-extras_size"]:checked'
    );

    this.buyingJourneyObject.panelOptionalExtras.values = [];
    this.buyingJourneyObject.panelOptionalExtras.totalPrice = 0;
    this.buyingJourneyObject.panelOptionalExtras.value = "";
    if (selectedOptionalExtras.length > 0) {
      selectedOptionalExtras.forEach((input) => {
        this.buyingJourneyObject.panelOptionalExtras.values.push({
          value: input.value,
          variantId: input.dataset.variantId,
          price: this.convertPrice(input.dataset.price),
          quantity: parseInt(this.buyingJourneyObject.panelSize.value) || 1,
        });
      });
      this.buyingJourneyObject.panelOptionalExtras.totalPrice =
        this.buyingJourneyObject.panelOptionalExtras.values.reduce(
          (acc, curr) => acc + curr.price,
          0
        );
      this.buyingJourneyObject.panelOptionalExtras.value =
        this.buyingJourneyObject.panelOptionalExtras.values
          .map((value) => value.value)
          .join(" , ");
    }

    if (this.buyingJourneyObject.postCode.value != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="post-code"]'
      );
      selectedOption.value = this.buyingJourneyObject.postCode.value;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    let classInstance = this;
    const postCodeOptions = this.buyingJourney.querySelector(
      'input[name="post-code"]'
    );
    const postCodeInputs = [postCodeOptions];
    classInstance.disableNextButtonOnEmptyInput(postCodeInputs);

    if (postCodeOptions) {
      postCodeOptions.addEventListener("change", function () {
        classInstance.buyingJourneyObject.postCode.value =
          postCodeOptions.value;
        classInstance.disableNextButtonOnEmptyInput(postCodeInputs);
      });
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  getpostcode() {
    console.log("Access Issues");
    const accessIssuesOptions = this.buyingJourney.querySelectorAll(
      'input[name="delivery_access_issues"]'
    );
    this.buyingJourney.setDisableNextButton();
    if (accessIssuesOptions) {
      accessIssuesOptions.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.buyingJourney.setDisableNextButton();
          const selectedAccessIssue = this.buyingJourney.querySelector(
            'input[name="delivery_access_issues"]:checked'
          );
          this.buyingJourneyObject.accessIssue.value =
            selectedAccessIssue.value;
          const accessIssueNote = this.buyingJourney.querySelector(
            'textarea[name="access_issues_order_note"]'
          );
          if (this.buyingJourneyObject.accessIssue.value == "Yes") {
            accessIssueNote.addEventListener("change", () => {
              this.buyingJourney.setDisableNextButton();
              this.buyingJourneyObject.accessIssue.orderNote =
                accessIssueNote.value;
              if (
                this.buyingJourneyObject.accessIssue.value == "Yes" &&
                this.buyingJourneyObject.accessIssue.orderNote != null &&
                this.buyingJourneyObject.accessIssue.orderNote.trim() !== ""
              ) {
                this.buyingJourney.setActiveNextButton();
              }
            });
          } else if (this.buyingJourneyObject.accessIssue.value == "No") {
            accessIssueNote.value = null;
            this.buyingJourneyObject.accessIssue.orderNote = null;
            if (
              this.buyingJourneyObject.accessIssue.value == "No" &&
              this.buyingJourneyObject.accessIssue.orderNote == null
            ) {
              this.buyingJourney.setActiveNextButton();
            }
          }
        });
      });
      if (this.buyingJourneyObject.accessIssue.value != null) {
        const selectedOption = this.buyingJourney.querySelector(
          'input[name="delivery_access_issues"][value="' +
          this.buyingJourneyObject.accessIssue.value +
          '"]'
        );
        selectedOption.checked = true;
        if (this.buyingJourneyObject.accessIssue.value == "Yes") {
          this.buyingJourney.querySelector(
            'input[name="access_issues_order_note"]'
          ).value = this.buyingJourneyObject.accessIssue.orderNote;
        }
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    console.log(this.buyingJourneyObject);
  }

  //Gate access
  getGatewayAccessQuote() {
    console.log("Gateway Access");
    if (this.buyingJourneyObject.gtAccessQoute.firstName != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[firstName]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.firstName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.lastName != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[lastName]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.lastName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.email != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[email]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.email;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    if (this.buyingJourneyObject.gtAccessQoute.mobile != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[name="contact[phone]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.mobile;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const accessQuoteInputs =
      this.buyingJourney.querySelectorAll(".step-gtaq input");
    this.disableNextButtonOnEmptyInput(accessQuoteInputs);
    accessQuoteInputs.forEach((input) => {
      input.addEventListener("change", () => {
        switch (input.name) {
          case "contact[firstName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.firstName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.firstName = null;
            }
            break;
          case "contact[lastName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.lastName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.lastName = null;
            }
            break;
          case "contact[phone]":
            {
              const IsValidFormat = this.buyingJourney.validateAndFormatPhone(
                input.value,
                "GB"
              );
              console.log("Is phone number is valid? " + IsValidFormat.valid);
              if (input.value.length == 11 && IsValidFormat.valid) {
                this.buyingJourneyObject.gtAccessQoute.mobile = input.value;
                input.classList.remove("invalid");
              } else {
                this.buyingJourneyObject.gtAccessQoute.mobile = null;
                input.classList.add("invalid");
              }
            }
            break;
          case "contact[email]":
            if (this.buyingJourney.validateEmail()) {
              console.log("valid Email");
              this.buyingJourneyObject.gtAccessQoute.email = input.value;
            } else {
              console.log("Invalid Email");
              this.buyingJourneyObject.gtAccessQoute.email = null;
            }
            break;
          default:
            console.log("no input");
            break;
        }

        if (
          this.buyingJourneyObject.gtAccessQoute.firstName &&
          this.buyingJourneyObject.gtAccessQoute.lastName &&
          this.buyingJourneyObject.gtAccessQoute.mobile &&
          this.buyingJourneyObject.gtAccessQoute.email
        ) {
          this.buyingJourney.setActiveNextButton();
        } else {
          this.buyingJourney.setDisableNextButton();
        }
      });
    });
  }

  getProductFinalPrice() {
    this.buyingJourneyObject.totalPrice = Math.round(
      this.convertPrice(
        this.buyingJourneyObject.panelSize.totalPrice +
        this.buyingJourneyObject.panelColour.totalPrice +
        this.buyingJourneyObject.panelOptionalExtras.totalPrice
      )
    );
    return this.buyingJourneyObject.totalPrice;
  }

  collectProductData() {
    const productData = {
      title: `Aluminium Garage Door ${this.buyingJourneyObject.panelInfo.panelWidth}x${this.buyingJourneyObject.panelInfo.panelHeight}`,
      handle: "your-order-" + this.buyingJourney.generateRandomSixDigitNumber(),
      body_html: `
          <p style="text-align: left;"><strong>Access issues: </strong> ${this.buyingJourneyObject.accessIssue.value == "No"
          ? this.buyingJourneyObject.accessIssue.value
          : this.buyingJourneyObject.accessIssue.orderNote
        }</p>
          <p style="text-align: left;"><strong>Manufacturing Size: </strong> ${this.buyingJourneyObject.panelInfo.panelWidth +
        "x" +
        this.buyingJourneyObject.panelInfo.panelHeight
        }</p>
          <p style="text-align: left;"><strong>Panels: </strong> ${this.buyingJourneyObject.panelSize.value
        }</p>
          <p style="text-align: left;"><strong>Panel colour: </strong> ${this.buyingJourneyObject.panelColour.value
        }</p>
          <p style="text-align: left;"><strong>Door type: </strong> ${this.buyingJourneyObject.panelInfo.doorType
        }</p>
          <p style="text-align: left;"><strong>Door fitting: </strong> ${this.buyingJourneyObject.panelInfo.doorFitting
        }</p>
          <p style="text-align: left;"><strong>Motor side: </strong> ${this.buyingJourneyObject.panelMotorSide.value
        }</p>
          <p style="text-align: left;"><strong>Optional extras: </strong>${this.buyingJourneyObject.panelOptionalExtras.value
        }</p>
          <p style="text-align: left;"><strong>Total price:</strong> £${this.getProductFinalPrice()} </p>
          `,
      vendor: "NOW Aluminium",
      product_type: "quote-product",
      variants: [
        {
          price: this.getProductFinalPrice(),
        },
      ],
      images: [
        {
          src: this.buyingJourneyObject.panelSize.panelImage, // Assuming this is the URL to the product image
        },
      ],
      properties: this.getProductProperties(),
    };
    return productData;
  }

  //Helper Functions

  validateInput(productObject, input) {
    const { buyingJourney } = this;
    if (input) {
      switch (input.name) {
        case "panel-width":
          productObject.panelInfo.panelWidth = parseInt(input.value, 10) || 0;
          break;
        case "panel-height":
          productObject.panelInfo.panelHeight = parseInt(input.value, 10) || 0;
        default:
          break;
      }
      var isValid = true;
      const value = parseInt(input.value, 10);
      if (!isNaN(value)) {
        isValid = true;
        if (input.hasAttribute("min") && input.hasAttribute("max")) {
          isValid = value >= input.min && value <= input.max;
        }
      }
      input.classList.toggle("invalid", !isValid);
      if (input.parentElement.nextElementSibling) {
        input.parentElement.nextElementSibling.classList.toggle(
          "show",
          !isValid
        );
      }
      if (this.validateStep()) {
        return true;
      } else {
        return false;
      }
    }
  }

  setIncrementForButtons(selectedFitting, triggerStepNumber = null) {
    const selectedFittingdowncased = selectedFitting.toLowerCase();
    switch (selectedFittingdowncased) {
      case "yes":
        this.buyingJourney.unskipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 0;
        break;
      case "no":
        this.buyingJourney.skipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 2;
        break;
      default:
        // do nothing
        break;
    }
  }

  setDecrementForButtons(selectedFitting) {
    const { buyingJourney } = this;
    switch (selectedFitting) {
      case "yes":
        this.buyingJourney.prevStepButton.dataset.decrement = 0;
        break;
      case "no":
        this.buyingJourney.prevStepButton.dataset.decrement = 2;
        break;
      case "skipAstragal":
        this.buyingJourney.prevStepButton.dataset.decrement = 3;
        break;
      default:
        // do nothing
        break;
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
  }

  validateStep() {
    const activeInputs = this.buyingJourney.querySelectorAll(
      ".step-container.active input"
    );
    return Array.from(activeInputs).every(
      (input) => input && input.value && !input.classList.contains("invalid")
    );
  }

  setupOptionListeners(selector) {
    const options = this.buyingJourney.querySelectorAll(selector);
    options.forEach((option) =>
      option.addEventListener("change", () => {
        if (option) option.checked = true;
        this.disableNextButtonOnNonSelection(options);
      })
    );
    this.disableNextButtonOnNonSelection(options);
  }

  disableNextButtonOnNonSelection(options) {
    const anyChecked = Array.from(options).some(
      (option) => option && option.checked
    );
    if (anyChecked) {
      this.buyingJourney.setActiveNextButton();
    } else {
      this.buyingJourney.setDisableNextButton();
    }
  }

  convertPrice(price) {
    let priceRounded;
    if (price) {
      let decimalPrice = parseFloat(price); // Convert the price to a float
      priceRounded = Math.round(decimalPrice * 100.0) / 100; // Multiply by 100, round, then divide by 100
    } else {
      priceRounded = 0;
    }
    return priceRounded;
  }

  disableNextButtonOnEmptyInput(inputs) {
    const allFilled = Array.from(inputs).every(
      (input) => input && input.value.trim() !== ""
    );
    let classInstance = this;
    if (allFilled) {
      classInstance.buyingJourney.setActiveNextButton();
    } else {
      classInstance.buyingJourney.setDisableNextButton();
    }
  }

  getProductProperties() {
    return {
      "First name": `${this.buyingJourneyObject.gtAccessQoute.firstName}`,
      "Last name": `${this.buyingJourneyObject.gtAccessQoute.lastName}`,
      Email: `${this.buyingJourneyObject.gtAccessQoute.email}`,
      Phone: `${this.buyingJourneyObject.gtAccessQoute.mobile}`,
      Postcode: `${this.buyingJourneyObject.postCode}`,
      "Panel width": `${this.buyingJourneyObject.panelInfo.panelWidth}`,
      "Panel height": `${this.buyingJourneyObject.panelInfo.panelHeight}`,
      "Panel color": `${this.buyingJourneyObject.panelColour.value}`,
      "Optional extras": `${this.buyingJourneyObject.panelOptionalExtras.value}`,
      "Door type": `${this.buyingJourneyObject.panelInfo.doorType}`,
      "Door fitting": `${this.buyingJourneyObject.panelInfo.doorFitting}`,
      "Motor side": `${this.buyingJourneyObject.panelMotorSide.value}`,
      Postcode: `${this.buyingJourneyObject.postCode.value}`,
      "Access issues": `${this.buyingJourneyObject.accessIssue.value}`,
      "Access issues note": `${this.buyingJourneyObject.accessIssue.orderNote}`,
      "Panel image": `${this.buyingJourneyObject.panelSize.panelImage}`,
      "Product type": `${this.buyingJourneyObject.productType}`,
      "Verified Email": `${this.buyingJourney.emailVerified}`,
      _buyingJourneyObject: this.buyingJourney.TokenUtils.encode(this.buyingJourneyObject),

    };
  }

  convertOrderItemsIntoProductObject(orderItem) {
    const props = orderItem.properties || {};

    let _buyingJourneyObject = null;
    if (props["_buyingJourneyObject"]) {
      if (!props["_buyingJourneyObject"].includes("{")) {
        _buyingJourneyObject = this.buyingJourney.TokenUtils.decode(props["_buyingJourneyObject"]);
      } else {
        _buyingJourneyObject = JSON.parse(props["_buyingJourneyObject"]);
      }
    }
    return {
      id: orderItem.id,
      product_id: orderItem.product_id,
      title: orderItem.product_title,
      totalPrice: orderItem.price,

      panelSize: {
        panelImage: orderItem.image || orderItem.properties["Panel image"],
      },

      panelInfo: {
        panelWidth: props["Panel width"],
        panelHeight: props["Panel height"],
        doorType: props["Door type"],
        doorFitting: props["Door fitting"],
      },

      panelColour: { value: props["Panel color"] },

      postCode: { value: props["Postcode"] },

      accessIssue: {
        value: props["Access issues"],
        orderNote: props["Access issues note"],
      },

      gtAccessQoute: {
        firstName: props["First name"],
        lastName: props["Last name"],
        mobile: props["Phone"],
        email: props["Email"],
      },

      productType: props["Product type"],

      panelMotorSide: { value: props["Motor side"] },
      panelOptionalExtras: { value: props["Optional extras"] },
      _buyingJourneyObject: {
        ..._buyingJourneyObject,
        id: orderItem.id,
        product_id: orderItem.product_id,
        title: this.buyingJourneyObject.title,
      },
    };
  }

  // Create individual quote item element
  createQuoteItemElement(item) {
    console.log("Hello World");
    const { buyingJourney } = this;
    const div = document.createElement("div");
    div.className = "bj-cart-bottom";
    div.innerHTML = `
      <div class="bj-cart-bottom-right-top accordion-toggle">
        <div class="cart-accor-header-left">
          <h2 class="bj-cart-heading accordion-toggle">${item.title}</h2>
          <div class="bj-cart-total-price">
            <span class="bj-cart-price" data-price="${item.totalPrice
      }" data-order-price>${Shopify.formatMoney(item.totalPrice)}</span>
            <span class="bj-cart-price-text">+ VAT</span>
          </div>
        </div>
        <div class="cart-accor-header-right">
          <a class="bj-cart-image-text removeQuoteProduct" data-item-id="${item.id
      }" data-product-id="${item.product_id}">
            <span>Remove</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <rect x="21.8047" y="0.199219" width="21.601" height="21.601" rx="10.8005" transform="rotate(90 21.8047 0.199219)" fill="#967b50"/>
              <path d="M8.45014 7.98345L14.0186 7.98345L14.0186 13.5519M13.6319 8.37015L7.9861 14.016" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
          <button type="button" class="accordion-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
              <rect y="0.224609" width="28" height="28" rx="14" fill="#967b50"></rect>
              <path d="M7.51465 15.8193L13.9999 9.33398L20.4852 15.8193" stroke="#f1f1f1" stroke-width="1.64706" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      </div>
      <div class="bj-cart-bottom-in">
        <div class="bj-cart-bottom-in-left">
          <div class="cart-item-image">
            <img id="order-featured-image" src="${item.panelSize.panelImage
      }" alt="${item.title}" class="bj-cart-image" />
          </div>
        </div>
        <div class="bj-cart-bottom-in-right">
          <div class="bj-cart-bottom-right-center">
            <h3 class="bj-cart-detail-heading">Your door</h3>
            <div class="bj-cart-details">
              ${buyingJourney.renderDetail(
        "Manufacturing size (mm)",
        `${item.panelInfo.panelWidth} x ${item.panelInfo.panelHeight}`,
        "step-1",
        1
      )}
              ${buyingJourney.renderDetail(
        "Optional extras",
        item.panelOptionalExtras.value,
        "step-6",
        6
      )}
              ${buyingJourney.renderDetail(
        "Panel colour",
        item.panelColour.value,
        "step-5",
        5
      )}
              ${buyingJourney.renderDetail(
        "Access issues",
        item.accessIssue.orderNote == "null"
          ? "No"
          : item.accessIssue.orderNote,
        "step-8",
        8
      )}
              ${buyingJourney.renderDetail(
        "Door type",
        item.panelInfo.doorType,
        "step-2",
        2
      )}
              ${buyingJourney.renderDetail(
        "Motor side",
        item.panelMotorSide.value,
        "step-4",
        4
      )}
              ${buyingJourney.renderDetail(
        "Door fitting",
        item.panelInfo.doorFitting,
        "step-3",
        3
      )}
              ${buyingJourney.renderDetail("Delivery", "Standard", "", 9)}
           </div>
          </div>
        </div>
      </div>
    `;

    // Attach remove handler

    div.querySelectorAll(".edit-option")?.forEach((option) =>
      option.addEventListener("click", () => {
        this.editHandler(option, item);
      })
    );
    return div;
  }

  editHandler(input, object) {
    const draftOrderId = this.buyingJourney.draftOrderId;
    const stepIndex = input.dataset.stepCount;
    // write an object to the localestoarge
    const editObject = {
      object,
      draftOrderId,
    };
    localStorage.setItem("modified-product", JSON.stringify(editObject));
    window.location.href = `/pages/garage-doors-builder?step=${stepIndex}&edit-order=true`;
  }
}

window.GarageDoor = GarageDoor;
